import {
  GuestUser,
  ParentUser,
  VisitorUser,
} from './users.api.interfaces';
import { TDocument } from '../documents/documents.interfaces';
import { TActions, TPaginatedResponse } from '../__shared/shared.interfaces';

export type TUserDetailsSimplified = {
  id: string;
  basicDetails: TPrimaryDetails;
};

export enum GENDER {
  MALE = 'male',
  FEMALE = 'female',
  OTHER = 'trans',
}

export type TUserDetailsSimplifiedObject = {
  [userId: string]: TUserDetailsSimplified;
};

export type TUserDetails = TUserDetailsSimplified & {
  actions: TActions;
  contactDetails: TContactDetails;
  documents: TDocument[]; // list of documents to verify the user - aadhar, pan, etc.
};

export type TPrimaryDetails = {
  id?: string;
  firstName: string;
  middleName?: string | null;
  lastName: string;
  gender: GENDER | 'select';
  /** Date of birth in YYYY-MM-DD format. */
  dateOfBirth?: string;
  profile?: {
    profilePicture?: TDocument;
    idProof?: TDocument;
    addressProof?: TDocument;
  };
  emergencyContact?: TEmergencyContact;
};

export type TEmergencyContact = TPrimaryDetails &
  TContactDetails & {
    relationship: string;
  };

export type TContactDetails = {
  _id?: string;
  phone: TPhoneDetails;
  email: TEmailDetails;
  address?: TAddressDetails | null;
};

export type TPhoneDetails = {
  countryCode: string;
  phoneNumber: string;
  isVerified: boolean;
};

export type TEmailDetails = {
  email: string;
  isVerified: boolean;
};

export type TAddressDetails = {
  _id?: string;
  address1: string;
  address2?: string | null;
  city: string;
  state?: string | null;
  country?: string | null;
  postalCode: string;
  isCurrent?: boolean | null;
  description?: string | null;
};

export type TUserListApiResponse = TPaginatedResponse<TUserDetails>;
export type TParentListApiResponse = TPaginatedResponse<ParentUser>;
export type TVisitorListApiResponse = TPaginatedResponse<VisitorUser>;
export type TGuestListApiResponse = TPaginatedResponse<GuestUser>;

// Staff-eligible users
export type TStaffEligibleUser = {
  id: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  email?: string;
  userRole: string;
  hasStaffRecord: boolean;
  addressId?: string;
  contactId?: string;
};

export type TStaffEligibleResponse = {
  data: TStaffEligibleUser[];
};

// Supervisors
export type TSupervisor = {
  id: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  userRole: string;
};

export type TSupervisorsResponse = {
  data: TSupervisor[];
};
